import RoundedButton from './RoundedButton';

export * from './RoundedButton';

export default RoundedButton;
